// extracted by mini-css-extract-plugin
module.exports = {"root":"Checkbox__root___S62VU","disabled":"Checkbox__disabled___vOc07","loading":"Checkbox__loading___MOxWJ","input":"Checkbox__input___Bz5L2"};